import { Input, Radio, Space, Checkbox,  } from "antd";
import React, {useRef} from "react";
const {TextArea} = Input;

export function QuestionAndAnswerItem (props){
    const {item, index, current, pageSize} = props;
    const {question, options, correctAnswer, reason, isMore} = item;

    return (
        <div className= 'container mt-2 d-flex justify-content-between flex-column multiple-choice'>
            <p style={{fontWeight: 'bold', fontSize: '14px'}}>
                {(current-1) * pageSize + props.index + 1} : {question}
            </p>
            <div style={{width: '100%'}}>
                <TextArea value={correctAnswer} disabled={true}/>
            </div>
            {isMore ?
                <p style={{fontSize: '14px', paddingTop: '5px'}}>Explaination: {reason}</p>
                :
                null
            }
        </div>
    );
}


export function EditQuestionAndAnswerItem(props){
    
    const {item, index} = props;
    const {question, options, correctAnswer, reason, url, question_id, page, document_id} = item;
    const onChange = ({target: {value}})=>{
        props.handleAnswerChange({correctAnswer: value});
    }

    const handleQuestionChange = ({target: {value}})=>{
        props.handleAnswerChange({question: value});
    }
    return (
        <>
            <Input defaultValue={question} onChange={handleQuestionChange}/>

            <div style={{width: '100%'}}>
                <TextArea defaultValue={correctAnswer} onChange={onChange}/>
            </div>
            <ImageDisplay imgList={url} isEdit={true} document_id={document_id} question_id={question_id} page={page}/>
        </>
    );
}